import { Model } from "./model";

export class UserQuiz extends Model {
    user_id: number;
    quiz_id: number;
    correct_answers: number;
    points: number;
}


// WEBPACK FOOTER //
// ./src/models/user-quiz.model.ts